import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FieldType, FormlyModule } from '@ngx-formly/core';
import { ICONS } from '../../../../_helpers/icons.constants';

/**
 * A card's header: title on the left, an optional action link on the right, an optional
 * hint underneath.
 *
 * Display-only - it holds no value, so it takes no key, the same way `formly-link` is used.
 * It replaces the `template: '<h6 class="...">' + translate(...) + '</h6>'` string pairs the
 * panels were assembling inline, which put markup and class names in the TS where nothing
 * could reuse or restyle them.
 *
 * Deliberately generic: nothing here is specific to a screen, so any card wanting a
 * title/link/hint header can use it.
 *
 * templateOptions:
 *   label     title text, already translated by the caller (the house style in these panels)
 *   hint      optional line under the title
 *   linkText  optional right-hand action; omit it and the title takes the full row
 *   click     handler for that action
 *   icon      optional icon src shown before the title
 */
@Component({
  selector: 'formly-section-header',
  templateUrl: './formly-section-header.component.html',
  standalone: true,
  imports: [CommonModule, FormlyModule],
})
export class FormlySectionHeaderComponent extends FieldType {
  public ICONS = ICONS;

  onLinkClick(): void {
    if (typeof this.to?.click === 'function') {
      this.to.click(this.field);
    }
  }
}
